import { createBrowserRouter, RouteObject } from 'react-router';

import { AppShell } from '@/components/layout/routes/AppShell.comp.tsx';
import { FullPageSpinner } from '@/components/ui/fullPageSpinner/FullPageSpinner.comp.tsx';
import { assertRouteAccess, contextMiddleware } from '@/middleware/contextMiddleware.middleware.ts';
import { ROUTES } from '@/models/route/routes.ts';
import { NotFound } from '@/views/generalError/notFound/NotFound.comp.tsx';

const routeObjects: RouteObject[] = ROUTES.map(({ children, component, load, path }) => {
  const middleware = [contextMiddleware(path)];
  const childRoutes: RouteObject[] | undefined = children?.map(child =>
    child.index
      ? { Component: child.component, index: true }
      : { Component: child.component, path: child.path },
  );

  if (load) {
    return {
      children: childRoutes,
      lazy: async () => {
        // route.lazy runs eagerly, in parallel with middleware — the access
        // check must happen here too, before the view chunk is requested
        await assertRouteAccess(path);
        const { default: View } = await load();
        return { Component: View };
      },
      middleware,
      path,
    };
  }

  return { children: childRoutes, Component: component, middleware, path };
});

export const router = createBrowserRouter([
  {
    children: [...routeObjects, { element: <NotFound />, path: '*' }],
    element: <AppShell />,
    hydrateFallbackElement: <FullPageSpinner />,
  },
]);
